export const languages = ['en', 'de', 'fr', 'nl'];
